import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

function applyInitialThemeClass() {
  try {
    const raw = localStorage.getItem('ui-storage');
    if (!raw) return;
    const parsed = JSON.parse(raw) as { state?: { theme?: 'dark' | 'light' } };
    const theme = parsed?.state?.theme;
    if (theme !== 'dark' && theme !== 'light') return;
    document.body.classList.remove('theme-dark', 'theme-light');
    document.body.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
  } catch {
    // ignore
  }
}

applyInitialThemeClass();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
